export const NETWORK_QUALITY_CHECK_FREQUENCY = 10; // seconds

export const NETWORK_QUALITY_CONFIG_LOCAL_VERBOSITY = 1; // LocalParticipant [1 - 3]
export const NETWORK_QUALITY_CONFIG_REMOTE_VERBOSITY = 3; // RemoteParticipants [0 - 3]

export const TWILIO_REFRESH_TOKEN_TIME = 3 * 60 + 30; // 3.5 hrs
export const AVAIL_ACCESS_TOKEN_TIME = 3 * 60 + 25; // 5 minutes before Twilio to prevent collision
